// extracted by mini-css-extract-plugin
export var compactFilters = "_du-4";
export var detailImage = "_du-1";
export var dropdownContainer = "_du-2";
export var imageContainer = "_du-0";
export var selectedCard = "_du-3";